<template>
  <div class="col-12 col-md-6 col-lg-3 shop-buttons mt-2 mt-lg-0 px-3 px-lg-0">
    <button @click="buttonClicked('hot')" 
    :class="{selected:hotSelected}" class="btn-custom btn-custom-red btn-custom-inline mr-3">
      <i class="fas fa-fire icon"></i>
      <span>Hot Items</span>
    </button>
    <button @click="buttonClicked('new')"
    :class="{selected:newSelected}" class="btn-custom btn-custom-primary btn-custom-inline">
      <i class="fas fa-tools icon"></i>
      <span>New Items</span>
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      categoryRoute: String
    },
    computed: {
      hotSelected() {
        return this.$page.props.category_id === this.$page.props.const.cat_hot
      },
      newSelected() {
        return this.$page.props.category_id === this.$page.props.const.cat_new        
      }
    },
    methods: {
      buttonClicked(type) {
        if (type === 'hot') {
          if (this.hotSelected) {
            this.viewCategory(this.categoryRoute, '')
          } else this.viewCategory(this.categoryRoute, this.$page.props.const.cat_hot)
        }

        if (type === 'new') {
          if (this.newSelected) {
            this.viewCategory(this.categoryRoute, '')
          } else this.viewCategory(this.categoryRoute, this.$page.props.const.cat_new)
        }
      },
      viewCategory(route, category) {
        this.$inertia.visit(this.route(route, {
          category: category,
          _query: {
            manufacturer: this.$page.props.manufacturer_id,
            query: this.$page.props.query
          }
        }))
      },
    }
  }
</script>
